import React, { Component } from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import { Checkbox } from '@atlaskit/checkbox';
import { FieldTextAreaStateless } from '@atlaskit/field-text-area';
import Form, { Field } from '@atlaskit/form';
import Modal from '@atlaskit/modal-dialog';
import Select from '@atlaskit/select';

// @source
import { Feedback } from '../../server';
import Messages from './Messages';
import Fragment from './Fragment';

const fieldLabel = {
  question: 'What would you like to know?',
  comment: "Let us know what's on your mind",
  bug: 'Describe the bug or issue',
  suggestion: "Let us know what you'd like to improve",
  empty: 'Select an option',
};

const selectOptions = [
  { label: 'Ask a question', value: 'question' },
  { label: 'Leave a comment', value: 'comment' },
  { label: 'Report a bug', value: 'bug' },
  { label: 'Suggest an improvement', value: 'suggestion' },
];

const defaultSelectValue = {
  label: 'I want to...',
  value: 'empty',
};

const initialState = {
  canBeContacted: false,
  description: '',
  enrollInResearchGroup: false,
  isLoading: false,
  message: false,
  type: 'empty',
};

class FeedbackColector extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.unmount = false;
    this.onChangeSelect = this.onChangeSelect.bind(this);
    this.onCloseMessage = this.onCloseMessage.bind(this);
    this.onSubmitHandle = this.onSubmitHandle.bind(this);
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  onChangeSelect(option) {
    this.setState({ type: option.value });
  }

  onCloseMessage() {
    this.setState({ message: false });
  }

  onSubmitHandle() {
    this.setState({
      isLoading: true,
      message: false,
    });

    Feedback({
      data: {
        canBeContacted: this.state.canBeContacted,
        description: this.state.description,
        enrollInResearchGroup: this.state.enrollInResearchGroup,
        type: this.state.type,
      },
      success: (messages) => {
        this.setStateUnmount({
          isLoading: false,
          message: (
            <Messages
              appearance="success"
              items={messages}
              onClose={this.onCloseMessage}
            />
          ),
        });
      },
      error: (messages) => {
        this.setStateUnmount({
          isLoading: false,
          message: (
            <Messages
              items={messages}
              onClose={this.onCloseMessage}
            />
          ),
        });
      },
    });
  }

  setStateUnmount(state) {
    if (this.unmount) return;
    this.setState(state);
  }

  render() {
    return (
      <Form name="feedback-collector">
        <Modal
          actions={[{
            appearance: 'primary',
            isDisabled: !this.state.description,
            isLoading: this.state.isLoading,
            onClick: this.onSubmitHandle,
            text: 'Send feedback',
            type: 'submit',
          }, {
            appearance: 'subtle',
            onClick: this.props.onClose,
            text: 'Cancel',
          }]}
          heading="Give feedback"
          onClose={this.props.onClose}
        >
          <Select
            defaultValue={defaultSelectValue}
            menuPortalTarget={document.body}
            onChange={this.onChangeSelect}
            options={selectOptions}
            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
          />
          <Fragment render={this.state.type !== 'empty'}>
            <Field
              isRequired
              label={fieldLabel[this.state.type]}
              validateOnBlur={false}
            >
              <FieldTextAreaStateless
                minimumRows={6}
                name="description"
                onChange={e => this.setState({ description: e.target.value })}
                shouldFitContainer
                value={this.state.description}
              />
            </Field>
            <Field>
              <Checkbox
                name="can-be-contacted"
                label="Robosoft can contact me about this feedback"
                onChange={event => this.setState({
                  canBeContacted: event.target.checked,
                })
                }
              />
            </Field>
            <Field>
              <Checkbox
                name="enroll-in-research-group"
                label="I'd like to participate in product research"
                onChange={event => this.setState({
                  enrollInResearchGroup: event.target.checked,
                })
                }
              />
            </Field>
          </Fragment>
          {this.state.message}
        </Modal>
      </Form>
    );
  }
}

FeedbackColector.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default FeedbackColector;
